module.exports = "/images/vendor/flag-icon-css/flags/4x3/cu.svg?750c91b200d29892cf10f9887253105f";